import { useMemo } from 'react';

export function useCustomFields(product, { fields }) {
  return useMemo(() => {
    const fallback = { extracted: {}, rest: [] };
    if (product) {
      if (!product.customFields) {
        return fallback;
      }

      const extracted = fields.reduce((customField, field) => {
        const f = product.customFields.find(({ key }) => key === field);
        if (f) {
          customField[field] = {
            ...f,
            value: f.htmlValue || f.listValue || f.stringValue || f.boolValue,
          };
        }
        return customField;
      }, {});
      const rest = product.customFields.filter(
        (field) => !fields.includes(field.key)
      );
      return { extracted, rest };
    } else {
      return fallback;
    }
  }, [product, fields]);
}
